import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  position: relative;
`;

export const SaveButtonContainer = styled.div`
  position: absolute;
  z-index: 1000;
  top: 12px;
  right: 12px;
`;
